import { ExistingClinicWithTreatmentsAndPromo } from '../../types';
import useClinicById from './useClinicById';

interface UseClinicWithTreatmentsReturn {
  clinic: ExistingClinicWithTreatmentsAndPromo | null;
  isLoading: boolean;
}

const useClinicWithTreatments = (clinicId: string): UseClinicWithTreatmentsReturn => {
  const { clinic, isLoading } = useClinicById(clinicId);
  const treatments = [];

  if (!clinic) {
    return {
      clinic: null,
      isLoading
    };
  }

  return {
    clinic: {
      ...clinic,
      conditions: treatments
    },
    isLoading
  };
};

export default useClinicWithTreatments;
